import React, { useEffect, useState } from "react";
import "./CookieConsent.css";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    const savedPrefs = localStorage.getItem("cookiePreferences");

    if (!consent) {
      setShowBanner(true);
    }

    if (savedPrefs) {
      try {
        setPreferences(JSON.parse(savedPrefs));
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  const saveConsent = (prefs, type) => {
    localStorage.setItem(
      "cookiePreferences",
      JSON.stringify(prefs)
    );

    localStorage.setItem("cookieConsent", type);

    setShowBanner(false);
    setShowSettings(false);
  };

  const acceptAll = () => {
    saveConsent(
      {
        necessary: true,
        analytics: true,
        marketing: true,
      },
      "accepted"
    );
  };

  const rejectAll = () => {
    saveConsent(
      {
        necessary: true,
        analytics: false,
        marketing: false,
      },
      "rejected"
    );
  };

  const savePreferences = () => {
    saveConsent(preferences, "custom");
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Bottom Banner */}

      <div className="cookie-banner">

        <div className="cookie-container">

          <div className="cookie-text">

            <h3>We Use Cookies</h3>

            <p>
              We use cookies to improve your experience on our site.
              Some cookies are essential for the site to function,
              while others help us understand how you use our site
              and improve our services.
            </p>

          </div>

          <div className="cookie-buttons">

            <button
              className="accept-btn"
              onClick={acceptAll}
            >
              Accept All
            </button>

            <button
              className="reject-btn"
              onClick={rejectAll}
            >
              Reject Non-Essential
            </button>

            <span
              className="settings-link"
              onClick={() => setShowSettings(true)}
            >
              Cookie Settings
            </span>

          </div>

        </div>

      </div>

      {/* Settings Popup */}

      {showSettings && (

        <div className="cookie-modal-overlay">

          <div className="cookie-modal">

            <div className="cookie-modal-header">

              <h2>Cookie Preferences</h2>

              <button
                className="close-btn"
                onClick={() => setShowSettings(false)}
              >
                ×
              </button>

            </div>

            <div className="cookie-modal-body">

              {/* Essential */}

              <div className="cookie-card">

                <div className="cookie-card-top">

                  <div className="cookie-title">

                    <input
                      type="checkbox"
                      checked
                      disabled
                    />

                    <strong>Essential Cookies</strong>

                  </div>

                  <span className="always-active">
                    Always Active
                  </span>

                </div>

                <p>
                  Required for the website to function properly.
                  Cannot be disabled.
                </p>

              </div>

              {/* Analytics */}

              <div className="cookie-card">

                <div className="cookie-card-top">

                  <div className="cookie-title">

                    <strong>Analytics Cookies</strong>

                  </div>

                  <label className="switch">

                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={(e) =>
                        setPreferences({
                          ...preferences,
                          analytics: e.target.checked,
                        })
                      }
                    />

                    <span className="slider"></span>

                  </label>

                </div>

                <p>
                  Help us understand how visitors use our
                  website to improve user experience.
                </p>

              </div>

              {/* Marketing */}

              <div className="cookie-card">

                <div className="cookie-card-top">

                  <div className="cookie-title">

                    <strong>Marketing Cookies</strong>

                  </div>

                  <label className="switch">

                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={(e) =>
                        setPreferences({
                          ...preferences,
                          marketing: e.target.checked,
                        })
                      }
                    />

                    <span className="slider"></span>

                  </label>

                </div>

                <p>
                  Used to deliver relevant advertisements
                  and track campaign performance.
                </p>

              </div>

            </div>

            <div className="cookie-modal-footer">

              <button
                className="save-btn"
                onClick={savePreferences}
              >
                Save Preferences
              </button>

              <button
                className="accept-btn"
                onClick={acceptAll}
              >
                Accept All
              </button>

              <button
                className="reject-btn"
                onClick={rejectAll}
              >
                Reject All
              </button>

            </div>

          </div>

        </div>

      )}
    </>
  );
}